import { inputRecipe } from "./input";
import { kbdRecipe } from "./kbd";
import { numberSelectorRecipe } from "./number-selector";
import { skeletonRecipe } from "./skeleton";

export const recipes = {
  input: inputRecipe,
  kbd: kbdRecipe,
  numberSelector: numberSelectorRecipe,
  skeleton: skeletonRecipe,
};
